import React from 'react'
import { constants, compose } from 'common/helpers'
import { connect } from 'redaction'

import injectGlobals from 'decorators/injectGlobals'
import Countdown from 'components/ui/countdown/Countdown/Countdown'


export default compose(
  injectGlobals(({ getFeatureToggle }) => ({
    isBillingDay1stEnabled: getFeatureToggle(constants.features.billingDay1stDayOfTheMonth),
  })),
  connect({
    startDate: (state, { isBillingDay1stEnabled }) => {
      const { models: { subscription: { subscriptionDate, unskipDate } } } = state

      const subDate       = subscriptionDate ? new Date(subscriptionDate) : 0
      const unskipedDate  = unskipDate ? new Date(unskipDate) : 0

      const firstDayDelimiter = isBillingDay1stEnabled ? 1  : 5
      const lastDayDelimiter  = isBillingDay1stEnabled ? 18 : 22

      // show Countdown after unskip made between 5th and 22th of the month only
      // https://scentbird.atlassian.net/browse/SCNT-3711
      const isUnskipFlow = (
        unskipedDate > subDate && unskipedDate.getDate() > firstDayDelimiter
        && unskipedDate.getDate() < lastDayDelimiter
      )

      return isUnskipFlow ? unskipedDate : subDate
    },
    hours: () => 12,
  })
)(Countdown)
